import { QUESTIONS_PER_ROUND, tierFor, type GuessReveal } from '@geosport/shared';

const DOT: Record<string, string> = {
  bullseye: 'bg-emerald-400',
  green: 'bg-green-500',
  yellow: 'bg-yellow-400',
  orange: 'bg-orange-400',
  red: 'bg-red-500',
};

/** "Question 2 of 5" with one dot per question, coloured by the tier already scored. */
export function QuestionPill({ position, reveals }: { position: number; reveals: GuessReveal[] }) {
  return (
    <div
      className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-bold text-white ring-1 ring-white/15"
      aria-label={`Question ${position} of ${QUESTIONS_PER_ROUND}`}
    >
      <span>
        Question {position} of {QUESTIONS_PER_ROUND}
      </span>
      <ol className="flex gap-1" aria-hidden="true">
        {Array.from({ length: QUESTIONS_PER_ROUND }, (_, i) => {
          const r = reveals[i];
          const cls = r
            ? DOT[tierFor(r.basePts)]
            : i + 1 === position
              ? 'bg-accent'
              : 'bg-white/25';
          return <li key={i} className={`h-2 w-2 rounded-full ${cls}`} />;
        })}
      </ol>
    </div>
  );
}
